import { useSyncExternalStore } from 'react'

export const PHONE_QUERY = '(max-width: 767px)'
export const DESKTOP_QUERY = '(min-width: 1024px)'
export const WIDE_QUERY = '(min-width: 1280px)'

function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (cb) => {
      const mq = window.matchMedia(query)
      mq.addEventListener('change', cb)
      return () => mq.removeEventListener('change', cb)
    },
    () => window.matchMedia(query).matches,
    () => false,
  )
}

/** Below the `md` breakpoint: bottom sheets instead of drawers, sheet pickers instead of popovers. */
export function useIsPhone(): boolean {
  return useMediaQuery(PHONE_QUERY)
}

/** From the `lg` breakpoint: room for two content columns (dashboard, detail pages with a side rail). */
export function useIsDesktop(): boolean {
  return useMediaQuery(DESKTOP_QUERY)
}

/** From the `xl` breakpoint: room for a side rail next to a main column. */
export function useIsWide(): boolean {
  return useMediaQuery(WIDE_QUERY)
}
